/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WORKERS_WERE_NOT_GIVEN_NOTICE_PRIOR_TO_TERMINATION_IN_LINE_WITH',
              'WORKERS_DID_NOT_HAVE_AN_OPPORTUNITY_TO_DEFEND_THEMSELVES_BEFORE',
              'WORKERS_WERE_TERMINATED_FOR_INVALID_REASONS',
              'WORKERS_WERE_NOT_PAID_CORRECTLY_FOR_OUTSTANDING_WAGES',
              'WORKERS_WERE_NOT_PAID_CORRECT_SEVERANCE_PAYMENTS',
              'TERMINATION_PAYMENTS_WERE_NOT_PAID_ON_TIME',
              'WORKERS_WERE_NOT_COMPENSATED_CORRECTLY_FOR_UNUSED_ANNUAL_LEAVE',
              'WORKERS_WERE_NOT_PAID_OTHER_TERMINATION_BENEFITS_IN_LINE_WITH_L',
              'THE_FACILITY_DID_NOT_COMPLY_WITH_ANY_ORDER_S_TO_REINSTATE_OR_CO',
              'DOES_THE_FACILITY_COMPLY_WITH_LEGAL_REQUIREMENTS_BEFORE_SUSPEND',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_items_below_apply_select_all_that_apply: valueSchema,
  },
}
